import { Component } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-insurance-notification',
  templateUrl: './insurance-notification.component.html',
  styleUrls: ['./insurance-notification.component.scss'],
})
export class InsuranceNotificationComponent {
  public get urlTermsAndConditions(): string {
    return `${environment.landingRapiflex}wp-content/uploads/2025/07/otrosi-de-acuerdo-economico-para-crear-cupo-de-endeudamiento-rotativo-y-servicio-de-firma-electronica.pdf`;
  }
}
